import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=1f669fe0&scoped=true&lang=pug&"
import script from "./MyTeam.vue?vue&type=script&lang=js&"
export * from "./MyTeam.vue?vue&type=script&lang=js&"
import style0 from "./MyTeam.vue?vue&type=style&index=0&id=1f669fe0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f669fe0",
  null
  
)

export default component.exports